import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import i18n from "../i18n";
import EnglishFlag from "../Images/usa.png";
import KurdistanFlag from "../Images/kurdstan.png";
import LanguageIcon from "@mui/icons-material/Language";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Button, Menu, Dropdown } from "antd";
import MenuItem from "antd/es/menu/MenuItem";
import "./Styles/Language.css";

const Language = () => {
  const { t } = useTranslation();
  const [language, setLanguage] = useState(Cookies.get("language") || "en");

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    i18n.changeLanguage(lang);
    Cookies.set("language", lang);
  };

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  const languageMenu = (
    <Menu
      style={{
        borderRadius: "12px",
        padding: "8px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
      }}
    >
      <MenuItem
        onClick={() => handleLanguageChange("en")}
        style={{
          borderRadius: "8px",
          margin: "4px 0",
          padding: "8px 16px",
          transition: "all 0.3s ease",
          "&:hover": {
            backgroundColor: "rgba(0,0,0,0.05)",
          },
        }}
      >
        <img
          src={EnglishFlag}
          alt="English"
          width="24"
          style={{
            marginRight: 12,
            borderRadius: "4px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        />
        <span
          style={{
            fontSize: "1rem",
            fontWeight: 500,
            color: "#333",
          }}
        >
          {t("English")}
        </span>
      </MenuItem>
      <MenuItem
        onClick={() => handleLanguageChange("ku")}
        style={{
          borderRadius: "8px",
          margin: "4px 0",
          padding: "8px 16px",
          transition: "all 0.3s ease",
          "&:hover": {
            backgroundColor: "rgba(0,0,0,0.05)",
          },
        }}
      >
        <img
          src={KurdistanFlag}
          alt="Kurdish"
          width="24"
          style={{
            marginRight: 12,
            borderRadius: "4px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        />
        <span
          style={{
            fontSize: "1rem",
            fontWeight: 500,
            color: "#333",
          }}
        >
          {t("Kurdish")}
        </span>
      </MenuItem>
    </Menu>
  );

  return (
    <div>
      {/* Language Selection Button */}
      <Dropdown overlay={languageMenu} trigger={["click"]}>
        <Button
          icon={<LanguageIcon />}
          shape="circle"
          size="large"
          className="scroll-to-top-button"
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            backgroundColor: "#1976d2",
            color: "white",
            zIndex: 1000,
            transition: "all 0.3s ease",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            border: "none",
            width: "48px",
            height: "48px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "&:hover": {
              backgroundColor: "#1565c0",
              transform: "translateY(-2px)",
              boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
            },
          }}
        />
      </Dropdown>

      {/* WhatsApp Contact Chat */}
      <Button
        type="primary"
        className="whatsapp-button"
        onClick={() => window.open("http://wa.link/6m9gla", "_blank")}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "80px",
          backgroundColor: "#25D366",
          color: "white",
          zIndex: 1000,
          width: "48px",
          height: "48px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          border: "none",
          transition: "all 0.3s ease",
          "&:hover": {
            backgroundColor: "#128C7E",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
          },
        }}
      >
        <WhatsAppIcon fontSize="large" />
      </Button>
    </div>
  );
};

export default Language;
